import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-Trash",
  "use": "svg-icon-Trash-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-Trash\"><path d=\"M12 6V5H3v10h9V6zm-2 1H5v6h5V7zM9 2h4v2H2V2h4V1h3v1zM6 7v6h1V7H6zm2 0v6h1V7H8z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol